import { css, unsafeCSS } from 'lit';

export const focusStyles = unsafeCSS(`
  outline-color: var(--tm-focus-ring-color);
  outline-offset: var(--tm-focus-ring-offset);
  outline-style: var(--tm-focus-ring-style);
  outline-width: var(--tm-focus-ring-width);
`);

export const base = {
  focus: css`
    :where(*:is(:focus-visible)) {
      ${focusStyles};
    }
  `,
};
